export default __webpack_public_path__ + "static/media/pen_art.26f86eb1.jpg";